module.exports = __webpack_public_path__ + "static/icon-planactions-5e05a6c89d3d190eb07a25abfa9ebca5.svg";